import { render, staticRenderFns } from "./ReguaHome.vue?vue&type=template&id=5cb4f4d9"
import script from "./ReguaHome.vue?vue&type=script&lang=js"
export * from "./ReguaHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports